import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { TopNumberList } from '@/components/modules/pages/top/list/TopNumberList';
import { TopSectionHead } from '@/components/modules/pages/top/typography/head/TopSectionHead';
import { Particles } from '@/components/ui/animation/Particles';
import { defaultOptions } from '@/components/ui/animation/Particles/options';
import { tailwindConfig } from '@/style/config';
const { colors } = tailwindConfig.theme;
/** 背景アニメーションの設定 */
const particlesOptions = defaultOptions({
    particleColor: colors['blue-gray'][100],
});
/**
 * TOPページ 数字で見るPROFFIT の大枠コンポーネント
 * @param props
 * @returns
 */
export const TopSeeInNumberBase = (props) => {
    const { className = '', listItems } = props;
    return (_jsxs("div", Object.assign({ className: clsx('bg-white', 'relative', 'px-20 pt-40 pb-64 lg:py-[81px]', className) }, { children: [_jsx(Particles, { className: 'absolute inset-0 z-[1] pointer-events-none', id: 'topSeeInNumberParticles', options: particlesOptions }), _jsxs("div", Object.assign({ className: 'relative z-10' }, { children: [_jsx(TopSectionHead, { children: "\u6570\u5B57\u3067\u898B\u308BPROFFIT" }), _jsx(TopNumberList, Object.assign({ className: clsx('w-[1020px] max-w-full', 'mx-auto mt-20 lg:mt-40') }, { children: listItems }))] }))] })));
};
